import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-foreground-400 text-xs md:text-sm font-medium tracking-widest uppercase block mb-3 font-heading">
            {aboutData.tag}
          </span>
          <h2 className="text-foreground-950 font-heading font-bold text-3xl md:text-4xl lg:text-5xl leading-tight mb-2">
            {aboutData.titleLine1}
            <span className="font-heading italic text-primary-500"> {aboutData.titleLine2} </span>
            {aboutData.titleLine3}
          </h2>
          <p className="text-foreground-400 text-sm md:text-base italic font-heading mt-3">
            {aboutData.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          <div className="bg-primary-100/70 rounded-2xl p-8 md:p-10 lg:p-12 relative overflow-hidden">
            <a href="#about" className="absolute top-6 right-6 w-10 h-10 rounded-full bg-white/60 flex items-center justify-center cursor-pointer hover:bg-white/80 transition-colors">
              <i className="ri-arrow-right-up-line text-primary-600"></i>
            </a>
            <div className="text-primary-400 font-heading font-bold text-5xl md:text-6xl lg:text-7xl mb-4">
              {aboutData.card1.percent}
            </div>
            <h3 className="text-foreground-900 font-heading font-bold text-xl md:text-2xl mb-2">
              {aboutData.card1.line1}
            </h3>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              {aboutData.card1.line2}
            </p>
            <p className="text-primary-500 font-heading italic text-sm md:text-base">
              —— {aboutData.card1.motto}
            </p>
          </div>

          <div className="bg-secondary-100/80 rounded-2xl p-8 md:p-10 lg:p-12 relative overflow-hidden">
            <a href="#about" className="absolute top-6 right-6 w-10 h-10 rounded-full bg-white/60 flex items-center justify-center cursor-pointer hover:bg-white/80 transition-colors">
              <i className="ri-arrow-right-up-line text-secondary-600"></i>
            </a>
            <div className="text-secondary-500 font-heading font-bold text-5xl md:text-6xl lg:text-7xl mb-4">
              {aboutData.card2.percent}
            </div>
            <h3 className="text-foreground-900 font-heading font-bold text-xl md:text-2xl mb-2">
              {aboutData.card2.line1}
            </h3>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              {aboutData.card2.line2}
            </p>
            <p className="text-secondary-600 font-heading italic text-sm md:text-base">
              —— {aboutData.card2.motto}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}